"use client";

import Image from "next/image";
import { Container } from "@/components/ui/tailwind-components";

type WeddingHeroPosterProps = {
  heroImage: string;
  coupleImage: string;
  ringsImage: string;
  label: string;
  title: string;
  date: string;
  names: string;
  tagline: string;
};

export function WeddingHeroPoster({
  heroImage,
  coupleImage,
  ringsImage,
  label,
  title,
  date,
  names,
  tagline,
}: WeddingHeroPosterProps) {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      {/* ================= HERO AREA ================= */}
      <div className="relative h-[70%] md:h-screen w-full bg-black">
        <Image
          src={heroImage}
          alt=""
          fill
          priority
          className="object-cover object-top"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/50 to-black/90" />

        {/* Text */}
        <div className="absolute inset-0 flex items-end justify-center px-4 pb-10 md:pb-16">
          <Container>
            <div className="text-center text-white space-y-3 md:space-y-4">
              <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase opacity-80">
                {label}
              </p>

              <h1 className="font-serif text-[32px] md:text-4xl tracking-widest">
                {title}
              </h1>

              <div className="inline-block border border-white/70 px-4 py-1 text-[11px] md:text-sm uppercase tracking-wide">
                {date}
              </div>

              <h2 className="font-serif text-[36px] md:text-5xl mt-2">
                {names}
              </h2>

              <div className="mx-auto h-6 w-px bg-white/60" />

              <p className="font-script text-[22px] md:text-2xl text-amber-300">
                {tagline}
              </p>
            </div>
          </Container>
        </div>
      </div>

      {/* ================= IMAGE STRIP (PART OF HERO) ================= */}
      <div className="grid grid-cols-2 h-[30%] w-full bg-black md:hidden">
        <div className="relative bg-black">
          <Image
            src={coupleImage}
            alt=""
            fill
            className="object-cover object-center"
          />
        </div>

        <div className="relative bg-black">
          <Image
            src={ringsImage}
            alt=""
            fill
            className="object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}
